import { AxiosInstance } from 'axios';

import * as common from '../../../../../../typings/api/skymap/rest/v1/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v1/geoid';

export class GeoidService implements types.Handlers {
  constructor(private axios: AxiosInstance) {}

  async getGeoids(params: types.GetGeoidsParameters): Promise<common.GetGeoidListResponse> {
    const { data } = await this.axios.get<common.GetGeoidListResponse>(`/v1/geoids`);
    return data;
  }

  async createGeoid(params: types.CreateGeoidParameters): Promise<common.GetGeoidResponse> {
    const { data } = await this.axios.post<common.GetGeoidResponse>(`/v1/geoids`, params.body);
    return data;
  }
}
